import { useInsertNationalStrategyOneMutation, NationalStrategyFragment } from '@app/generated/graphql';
import DescriptionIcon from '@material-ui/icons/Description';
import { pageContent } from '@app/shared/hoc/page-content';
import React from 'react';
import PageTitle from '@app/shared/components/PageTitle';
import BackButton from '@app/shared/components/buttons/BackButton';
import { InfoCard } from '@mystiny/ui';
import { useResponseBar } from '@app/shared/hooks/useResponseBar';
import { FormProvider, useForm } from 'react-hook-form';
import Spacing from '@app/components/common/Spacing';
import { Typography } from '@material-ui/core';
import SaveButton from '@app/shared/components/buttons/SaveButton';
import Page from '@app/components/Page';
import { Form } from '@app/views/ProjectStrategy/components/Form';
import { useHistory } from 'react-router-dom';

const StrategySubjecCreate = () => {
  const form = useForm<NationalStrategyFragment>();
  const history = useHistory();
  const { enqueueSuccess, enqueueFailure } = useResponseBar();
  const [createFn] = useInsertNationalStrategyOneMutation({
    onCompleted: ({ national_strategy }) => {
      enqueueSuccess('บันทึกข้อมูลสำเร็จ');
      history.push('/bof/projects/master-data/strategy-subject/' + national_strategy?.id);
    },
    onError: (err: any) => {
      console.error(err);
      enqueueFailure('เกิดข้อผิดพลาด' + err);
    },
  });
  const handleSubmit = form.handleSubmit((formData: NationalStrategyFragment) => {
    createFn({
      variables: {
        object: {
          id: formData.id,
          name: formData.name,
          parent_id: formData.parent_id,
          depth: formData.depth,
        },
      },
    });
  });

  return (
    <Page
      title={
        <PageTitle
          title={
            <React.Fragment>
              <Typography variant="h6" component="div">
                <DescriptionIcon color="primary" fontSize="small" /> สร้างข้อมูล
              </Typography>
            </React.Fragment>
          }
          actions={
            <div>
              <BackButton to="/bof/projects/master-data/strategy-subject" />
            </div>
          }
        />
      }
    >
      <Spacing />
      <InfoCard title="รายละเอียดข้อมูล" actionTopRight={<SaveButton onClick={handleSubmit} />}>
        <FormProvider {...form}>
          <Form mode="create" />
        </FormProvider>
      </InfoCard>
      <Spacing />
    </Page>
  );
};

export default pageContent(StrategySubjecCreate);
